import { Step } from '@opendoor/cinderblocks/sell/Timeline';

import {
  OdProtosBuyerData_User_CreditRating,
  OdProtosCommonMarket_Market,
} from '__generated__/globalTypes';

export const SCHEDULE_EXTERIOR_ASSESSMENT_IMG = '8858e690d04b40b2a75e1850afc216e5.svg';

export enum HomeWalkthroughOptions {
  SSVA = 'SSVA',
  ORVA = 'ORVA',
}

export enum SsvaUploadPageSourceOptions {
  ITERABLE = 'iterable',
  DASHBOARD = 'dashboard',
}

export enum HelloSignWizardStep {
  FORM_STEP = 1,
  SUMMARY_STEP = 2,
}

export enum BuyingTasksType {
  BuyingPower,
  FeedSetUp,
  CreateOffer,
  ScheduleTour,
  Prequalification,
}

export enum BuyModuleSections {
  TaskLinks = 0,
  BuyTasks,
  BuyJourney,
}

// TODO: Drop the use of this constant in favor of using the market data stored in web or PBDB
export const BWOD_MARKETS = [
  { label: 'Albuquerque, NM', value: OdProtosCommonMarket_Market.ALBUQUERQUE_NM },
  { label: 'Atlanta, GA', value: OdProtosCommonMarket_Market.ATLANTA },
  { label: 'Austin, TX', value: OdProtosCommonMarket_Market.AUSTIN },
  { label: 'Birmingham, AL', value: OdProtosCommonMarket_Market.BIRMINGHAM_AL },
  { label: 'Boise, ID', value: OdProtosCommonMarket_Market.BOISE },
  { label: 'Boston, MA', value: OdProtosCommonMarket_Market.BOSTON_MA },
  { label: 'Charleston, SC', value: OdProtosCommonMarket_Market.CHARLESTON_SC },
  { label: 'Charlotte, NC', value: OdProtosCommonMarket_Market.CHARLOTTE },
  { label: 'Chattanooga, GA/TN', value: OdProtosCommonMarket_Market.CHATTANOOGA },
  { label: 'Cincinnati, OH', value: OdProtosCommonMarket_Market.CINCINNATI_OH },
  { label: 'Cleveland, OH', value: OdProtosCommonMarket_Market.CLEVELAND_OH },
  { label: 'Colorado Springs, CO', value: OdProtosCommonMarket_Market.COLORADO_SPRINGS_CO },
  { label: 'Columbia, SC', value: OdProtosCommonMarket_Market.COLUMBIA_SC },
  { label: 'Columbus, OH', value: OdProtosCommonMarket_Market.COLUMBUS_OH },
  { label: 'Corpus Christi, TX', value: OdProtosCommonMarket_Market.CORPUS_CHRISTI_TX },
  { label: 'Dallas-Fort Worth, TX', value: OdProtosCommonMarket_Market.DALLAS },
  { label: 'Denver, CO', value: OdProtosCommonMarket_Market.DENVER },
  { label: 'Detroit, MI', value: OdProtosCommonMarket_Market.DETROIT_MI },
  { label: 'Greensboro, NC', value: OdProtosCommonMarket_Market.GREENSBORO_NC },
  { label: 'Greenville, SC', value: OdProtosCommonMarket_Market.GREENVILLE_SC },
  { label: 'Houston, TX', value: OdProtosCommonMarket_Market.HOUSTON },
  { label: 'Indianapolis, IN', value: OdProtosCommonMarket_Market.INDIANAPOLIS_IN },
  { label: 'Jacksonville, FL', value: OdProtosCommonMarket_Market.JACKSONVILLE },
  { label: 'Kansas City, KS/MO', value: OdProtosCommonMarket_Market.KANSAS_CITY },
  { label: 'Killeen, TX', value: OdProtosCommonMarket_Market.KILLEEN_TX },
  { label: 'Knoxville, TN', value: OdProtosCommonMarket_Market.KNOXVILLE_TN },
  { label: 'Las Vegas, NV', value: OdProtosCommonMarket_Market.LAS_VEGAS },
  { label: 'Los Angeles, CA', value: OdProtosCommonMarket_Market.LOS_ANGELES },
  { label: 'Miami, FL', value: OdProtosCommonMarket_Market.MIAMI_FL },
  { label: 'Minneapolis-Saint Paul, MN', value: OdProtosCommonMarket_Market.MINNEAPOLIS },
  { label: 'Nashville, TN', value: OdProtosCommonMarket_Market.NASHVILLE },
  { label: 'New York / New Jersey, NY', value: OdProtosCommonMarket_Market.NEW_YORK_NEW_JERSEY },
  { label: 'Northern Colorado, CO', value: OdProtosCommonMarket_Market.NORTHERN_COLORADO },
  { label: 'Oklahoma City, OK', value: OdProtosCommonMarket_Market.OKLAHOMA_CITY_OK },
  { label: 'Orlando, FL', value: OdProtosCommonMarket_Market.ORLANDO },
  { label: 'Phoenix, AZ', value: OdProtosCommonMarket_Market.PHOENIX },
  { label: 'Portland, OR', value: OdProtosCommonMarket_Market.PORTLAND },
  { label: 'Prescott, AZ', value: OdProtosCommonMarket_Market.PRESCOTT_AZ },
  { label: 'Raleigh-Durham, NC', value: OdProtosCommonMarket_Market.RALEIGH },
  { label: 'Richmond, VA', value: OdProtosCommonMarket_Market.RICHMOND_VA },
  { label: 'Riverside, CA', value: OdProtosCommonMarket_Market.RIVERSIDE },
  { label: 'Sacramento, CA', value: OdProtosCommonMarket_Market.SACRAMENTO },
  { label: 'Salt Lake City, UT', value: OdProtosCommonMarket_Market.SALT_LAKE_CITY },
  { label: 'San Antonio, TX', value: OdProtosCommonMarket_Market.SAN_ANTONIO },
  { label: 'San Diego, CA', value: OdProtosCommonMarket_Market.SAN_DIEGO_CA },
  { label: 'San Francisco Bay Area, CA', value: OdProtosCommonMarket_Market.SF_BAY_AREA },
  { label: 'Southwest, FL', value: OdProtosCommonMarket_Market.SOUTHWEST_FL },
  { label: 'St. Louis, MO', value: OdProtosCommonMarket_Market.ST_LOUIS },
  { label: 'Tampa, FL', value: OdProtosCommonMarket_Market.TAMPA },
  { label: 'Tucson, AZ', value: OdProtosCommonMarket_Market.TUCSON },
  { label: 'Washington, DC', value: OdProtosCommonMarket_Market.WASHINGTON_DC },
] as const;

export type MARKET = (typeof BWOD_MARKETS)[number]['value'];

export const CREDIT_SCORE_VALUES: Array<{
  label: string;
  value: OdProtosBuyerData_User_CreditRating;
}> = [
  { label: '720+ (Excellent)', value: OdProtosBuyerData_User_CreditRating.EXCELLENT },
  { label: '660-719', value: OdProtosBuyerData_User_CreditRating.GOOD },
  { label: '620-659', value: OdProtosBuyerData_User_CreditRating.AVERAGE },
  { label: '619 or below', value: OdProtosBuyerData_User_CreditRating.LOW },
  { label: "I don't know", value: OdProtosBuyerData_User_CreditRating.UNKNOWN_CREDIT_RATING },
];

export const BUYING_POWER_STEPS: { [step: number]: { text: string; buttonText: string } } = {
  1: {
    text: 'How much do you still owe on the house you’re selling?',
    buttonText: 'Next - Down payment',
  },

  2: {
    text: 'How much do you plan for your down payment?',
    buttonText: 'Next - Annual income',
  },

  3: {
    text: 'How much do you make in a year before taxes?',
    buttonText: 'Next - Monthly bills',
  },

  4: {
    text: 'How much are your bills each month?',
    buttonText: 'Next - Credit score',
  },

  5: {
    text: 'What’s your credit score?',
    buttonText: 'See my buying power',
  },
};

export enum SellDirectPreSignTimelineItems {
  REQUEST_OFFER = 'Request offer',
  CHOOSE_PLAN = 'Compare options',
  OFFER_REVIEW = 'Review with expert',
  SHOW_US_YOUR_HOME = 'Show us your home',
  BOOK_INTRO_CALL = 'Book intro call',
  SHOW_US_THE_HOME = 'Show us the home',
  REVIEW_WITH_EXPERT = 'Review with expert',
  HOME_ASSESSMENT = 'In-person assessment',
  FINALIZED_OFFER = 'Get final numbers',
  SIGN = 'Sign',
  CLOSE_AND_GET_PAID = 'Close & get paid',
  SIGN_AND_CLOSE = 'Sign and close',
  SET_UP_CONTRACT = 'Set up contract', // This intend to replace SIGN_AND_CLOSE step, and we should clean up SIGN_AND_CLOSE step once we fully rollout Novo
}

/**
 * Returns correct timeline steps based on arguments
 */
export const getSellDirectPreSignTimelineSteps = ({
  isAgent = false,
  isSkippingHomeAssessment = false,
}: {
  isAgent?: boolean;
  isSkippingHomeAssessment?: boolean;
} = {}): Step[] => {
  const steps = [
    {
      name: SellDirectPreSignTimelineItems.REQUEST_OFFER,
    },
    {
      name: isAgent
        ? SellDirectPreSignTimelineItems.SHOW_US_THE_HOME
        : SellDirectPreSignTimelineItems.SHOW_US_YOUR_HOME,
    },
    isSkippingHomeAssessment
      ? null
      : {
          name: SellDirectPreSignTimelineItems.HOME_ASSESSMENT,
        },
    {
      name: SellDirectPreSignTimelineItems.FINALIZED_OFFER,
    },
    {
      name: SellDirectPreSignTimelineItems.SIGN_AND_CLOSE,
    },
  ];

  return steps.filter(Boolean) as Step[];
};

// i.e 9175b5bc-c7b6-5650-9cbf-2c77a364f383
// i.e d7e7bf34-c23b-4a81-80ce-731f41b33088 (case insensitive)
export const UUID_REGEX =
  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
// i.e. ?query=param&another=param
export const QUERY_PARAM_REGEX = /(\?|&)([^=]+)=([^&]+)$/g;
